"use client";

import TextTruncate from "@/components/common/textTruncate/TextTruncate";
import Button from "@/components/ui/button/Button";
import Image, { ImageProps } from "next/image";
import NoImage from "@/assets/images/no_image.svg"

interface IEventCardProps {
  imgSrc: ImageProps;
  variant?: "variant-1" | "variant-2";
}
const EventCard = ({ imgSrc, variant = "variant-1" }: IEventCardProps) => {
  return (
    <div
      className={`pt-9 text-center md:px-0 md:pt-0 ${variant === "variant-1" && "lg:text-left"} `}
    >
      <div className="relative">
        <Image src={imgSrc.src ?? NoImage.src} alt={imgSrc.alt} height={249} width={375} className="w-full" />
      </div>

      <div className="">
        <h2 className="pt-5 text-xl font-semibold lg:pt-4 lg:text-3xl">
          Lorem ipsum dolor sit smet
        </h2>
        <div className={`${variant !== "variant-1" && "hidden"}`}>
          <p className="pt-5 text-base lg:pt-[2px] lg:text-xl">
            Sunday,20th of August from 8:00am-9:00pm
          </p>
          <p className="text-base">Ground Floor,Sahara Mall,Sharjah,UAE 052-1406939</p>
          <TextTruncate
            className="pt-2 text-base text-tertiary-6 lg:pt-3 lg:text-start lg:text-xl"
            text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius esse optio totam libero
          placeat sint tenetur numquam, reiciendis harum repellendus! Non totam pariatur cum
          sapiente? Nisi odio error vero eos"
          />
        </div>
        <div
          className={`flex justify-center pt-4 lg:pt-6 lg:text-center ${variant === "variant-1" && "hidden"}`}
        >
          <Button className="flex h-9 w-44 items-center justify-center">Read all</Button>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
